<div class="metric-bar-holder">
  <div class="time-progress-holder">
    <div class="pointer-label" *ngIf="planningSession.timePassedPercentage > 0 && planningSession.timePassedPercentage < 95" [style.left.%]="planningSession.timePassedPercentage">
      {{ "today_cap" | localize }}
    </div>
    <div class="time-progress">
      <div class="pointer" [style.left.%]="planningSession.timePassedPercentage"></div>
    </div>
    <div class="soft-deadline" *ngIf="metric.percentTimeToSoftDeadline" [style.width.%]="metric.percentTimeToSoftDeadline">
      <div class="drop" [uiTooltipTitle]="'soft_deadline_due_discontinued' | localize : { formattedDate: formattedSoftDueDate }" ui-tooltip></div>
    </div>
  </div>
  <div class="metric-bar" [style.width.%]="metric.percentTime">
    <div class="metric-bar-progress" *ngIf="coloringStrategy === 'colors' || coloringStrategy === 'both'" [style.width.%]="metric.attainment * 100" [style.background-color]="metric.color"></div>
    <div class="metric-bar-progress" *ngIf="coloringStrategy !== 'colors' && coloringStrategy !== 'both'" [style.width.%]="metric.attainment * 100" [style.background]="'#2e4354'"></div>
  </div>
</div>
